import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=6838957d&scoped=true&"
import script from "./AlertError.vue?vue&type=script&lang=js&"
export * from "./AlertError.vue?vue&type=script&lang=js&"
import style0 from "./AlertError.vue?vue&type=style&index=0&id=6838957d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838957d",
  null
  
)

export default component.exports